export default function () {
    return function (task, currentUserName) {
        task.isOwned = task.ownedBy !== null;
        task.isOwnedByCurrentUser = task.ownedBy === currentUserName;
        task.isOwnedByOtherUser = task.isOwned && !task.isOwnedByCurrentUser;

        return task;
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/tasks/applyTaskOwnershipState.js